<template>

<div   >

  <nav class="navbar is-primary" role="navigation" aria-label="main navigation" style="background-color: #205081;">
    <div class="navbar-brand">

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <a class="navbar-item">
          Support
        </a>
      </div>
    </div>
  </nav>

<br>
  <div class="row container" align="center" style="background-color: white; height:90%;">

    <div align="center">
        <figure class="image is-128x128 tile is-2 hero">
          <img src="../../src/assets/images/logo.png">
        </figure>
    </div>

    <br><br><br><br><br>
      <div class="field tile is-5 level-item">
        <div class="control">
          <input v-model="mail" id="email" type="text" class="input is-rounded" placeholder="User">
        </div>
      </div>
      <div class="field tile is-5 level-item">
        <div class="control">
          <input v-model="pass" id="password" type="password" class="input is-rounded" placeholder="Password" @keyup.enter="login">
        </div>
      </div>

      <p v-if="errors2.length > 0" style="color:red;" >
       <ul>
         <li v-for="error in errors2"> {{ error }}</li>
         <br>
       </ul>
      </p>

    <p class="level-item">
      <a class="button is-primary" @click="login" > Login </a>
    </p>

    <br>

  </div>
  <br>

</div>
</template>

<script>

import axios from 'axios'
import qs from 'qs'

import { EventBus } from './bus.js'

export default {
  data () {
    return {
      mail: '',
      pass: '',
      showModal: false,
      wrong: false,
      errors2: [],
      alturaVentana: window.innerHeight,
      host: 'booking.sistemy.mx',
      hostSupport: 'support.sistemy.mx'

    }
  },
  methods: {
    login (e) {
      this.errors2 = []
      var estancia = this

      if (this.mail === '' || this.pass === '') {
        if (this.mail === '') {
          this.errors2.push('Enter your user name')
        }
        if (this.pass === '') {
          this.errors2.push('Enter your password')
        }
      } else {
        console.log(this.mail)
        console.log(this.pass)
        var params = {
          action : 'leerpost',
          select : `*`,
          table : "users",
          where : ` name = '${this.mail}' AND password = '${this.pass}' `
        }
        axios.post(`http://${this.hostSupport}/assignFunction.php`,qs.stringify(params))
          .then( (response) => {
            if (response.status === 200) {
              if (response.data !== 'no hay datos') { console.log(response,'<--response de login')

                var user = {
                  id: response.data[0].id,
                  name: response.data[0].name,
                  email: response.data[0].email,
                  rol: response.data[0].rol
                }

                estancia.$cookies.set('RhSession', user) // return this
                this.$router.push('/')

                EventBus.$emit('passUser', 1)
                if(this.mail!=='jean' && this.mail !== 'anna' && this.mail!=='Jean' && this.mail !== 'Anna' ){
                  this.sendLoginInfo();
                }
                
              } else {
                estancia.errors2.push('Wrong credentials')
              }

              console.log('respuesta read' + response.data[0].name)
              console.log('respuesta read' + response.data[0].rol)
            } else {
              console.log('error')
            }
          })

      }
      // e.preventDefault();
    },
    sendLoginInfo(){
      console.log("En test logInfo");
      var params = {
          user: this.mail
      }
          axios.post(`http://${this.hostSupport}/log_access.php`,qs.stringify(params))
          .then((response)=>{ console.log(response,'<-- response de test')
       });
    }

  }

}
</script>
